
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
}
